import { Link } from "react-router-dom";
import { ChevronLeft, Mail, Phone } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20 sm:pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-lg">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors mb-8"
          >
            <ChevronLeft className="w-4 h-4" aria-hidden />
            Volver al inicio
          </Link>

          <article className="rounded-3xl border border-border/60 bg-card/40 backdrop-blur-sm shadow-xl overflow-hidden">
            <header className="px-6 sm:px-10 pt-8 sm:pt-10 pb-6 border-b border-border/40 bg-gradient-to-br from-primary/5 to-accent/5">
              <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground">Contacto</h1>
              <p className="mt-2 text-sm text-muted-foreground">Habily · GABI IA</p>
            </header>
            <div className="px-6 sm:px-10 py-8 sm:py-10 space-y-8">
              <div className="flex gap-4">
                <div className="shrink-0 w-11 h-11 rounded-2xl bg-primary/15 flex items-center justify-center border border-primary/20">
                  <Mail className="w-5 h-5 text-primary" aria-hidden />
                </div>
                <div>
                  <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-1">Email</h2>
                  <a
                    href="mailto:info@habily.es"
                    className="text-lg font-medium text-foreground hover:text-primary transition-colors break-all"
                  >
                    info@habily.es
                  </a>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="shrink-0 w-11 h-11 rounded-2xl bg-primary/15 flex items-center justify-center border border-primary/20">
                  <Phone className="w-5 h-5 text-primary" aria-hidden />
                </div>
                <div>
                  <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-1">Teléfono</h2>
                  <a
                    href="tel:+34615337318"
                    className="text-lg font-medium text-foreground hover:text-primary transition-colors"
                  >
                    615337318
                  </a>
                </div>
              </div>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
